module.exports = __webpack_public_path__ + "media/assets/pngs/slackLogo-2824feb83e0fcbebe2db97aee55cc846.png";